module.exports = __webpack_public_path__ + "static/icons/elevation-forecast-img-mid-13b903b91da0c161692b44a2c7db8296.svg";